import PageLayout from "@components/core/layouts/PageLayout";
import CardSection from "@components/core/section/CardSection";
import { requestLogout } from "@state/auth/AuthEffects";
import { requestGetLogoutDetails } from "@state/logoutDetails/LogoutDetailsEffects";
import { toastError } from "@utils/helpers/toast-helper";
import { FunctionComponent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const LogoutScreen: FunctionComponent = () => {
  const { t } = useTranslation();

  const [urlCas, setUrlCas] = useState<string | undefined>();

  useEffect(() => {
    requestGetLogoutDetails({})
      .then((response) => {
        if (response.ok && response.data) {
          setUrlCas(response.data.urlCas);
          requestLogout({})
            .then(() => {
              setTimeout(() => {
                if (response.data?.urlTarget) {
                  window.location.href = response.data?.urlTarget;
                }
              }, 5000); // Redirection après 5 secondes
            })
            .catch(() => {
              toastError(t("logout.error.jse"));
            });
        }
      })
      .catch(() => {
        toastError(t("logout.error.ce"));
      });
  }, []);

  return (
    <PageLayout bodyClassName="app-error-screen pt-5 d-flex flex-column flex-xl-row align-items-center justify-content-center">
      <>
        <CardSection title={t("logout.logout")}>
          <div>
            <p>{t("logout.description")}</p>
            <a className="cursor-pointer" href={urlCas} target="_self">
              {t("logout.casLogout")}
            </a>
          </div>
        </CardSection>
      </>
    </PageLayout>
  );
};

export default LogoutScreen;
